import type { Clip, User, Version } from './types'

/** Final Review is an inventory of editor returns, never rough suggestions. */
export function latestFinalVersion(clip: Clip | null | undefined): Version | null {
  if (!clip || clip.return_folder_available === false) return null
  const versions = [...(clip.versions || []), ...(clip.version ? [clip.version] : [])]
  return versions.filter(version => version.kind === 'final' && version.return_available !== false).sort((a, b) => b.number - a.number)[0] || null
}

export function isFinalReviewClip(clip: Clip) {
  return ['final_review', 'complete', 'changes_requested', 'editing'].includes(clip.status) && Boolean(latestFinalVersion(clip))
}

export function canUploadFinal(clip: Clip, user: User) {
  return clip.claimed_by?.id === user.id &&
    ['editing', 'changes_requested'].includes(clip.status) && Boolean(clip.approved_version_id)
}
